import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Box } from '@material-ui/core'
import { useStyles } from './style'
import _ from 'lodash'
import * as messageTypes from '../../utils/messageTypes'
import { ComponentLoader, DisplayMessage } from '..'
import RefreshIcon from '@material-ui/icons/Refresh'
import { getTableHeadings } from './constant'
import { TableOutline } from '../../elements'
import { programService } from '../../Services'
import StatusButton from '../StatusButton'
import { useHistory } from 'react-router'

const Accounts = (props) => {
  const classes = useStyles()
  const [programs, setPrograms] = useState([])
  const [tableData, setTableData] = useState([])
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [totalCount, setTotalCount] = useState(0)
  const [tableHeadings, setTableHeadings] = useState(getTableHeadings(classes))
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState()
  const [loading, setLoading] = useState(false)
  const { currentUser } = props
  const rowsPerPageOptions = [5, 10, 25, 50]
  const history = useHistory()

  const getAllAccountsDetails = () => {
    setLoading(true)
    programService.getAllProgramsDetails(currentUser.account_id, page - 1, rowsPerPage)
      .then(programData => {
        setPrograms(programData.programs)
        getTableData(programData.programs)
        setTotalCount(programData.total_count)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Failed to get program details'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getTableData = (accountsData) => {
    let accountsTable = []
    accountsData.map(obj => {
      let tableObj = [
        {
          id: 'programName',
          value: _.get(obj, 'name', '-'),
          handleClick: () => history.push(`program-details/${obj.id}`)
        },
        {
          id: 'accountName',
          value: _.get(obj, 'account_name', '-'),
        },
        {
          id: 'numberOfUsers',
          value: _.get(obj, 'number_of_users', '-'),
          className: `${classes.textRight}`
        },
        {
          id: 'systemsEnrolled',
          value: !_.isNil(obj.system_enrolled) ? obj.system_enrolled : '-',
          className: `${classes.textRight}`
        },
        {
          id: 'totalEnergy',
          value: obj && typeof obj.total_energy === 'number' ? _.get(obj, 'total_energy', 0).toFixed(2) : '-',
          className: `${classes.textRight}`
        },
        {
          id: 'totalPower',
          value: obj && typeof obj.total_power === 'number' ? _.get(obj, 'total_power', 0).toFixed(2) : '-',
          className: `${classes.textRight}`
        },
        {
          id: 'status',
          value: obj && obj.status && <StatusButton color={obj.status === 'Yes' ? '#7ACF38' : '#F05252'} text={obj.status === 'Yes' ? 'Active' : 'Inactive'} />,
        }
      ]
      accountsTable.push(tableObj)
    })
    setTableData(accountsTable)
  }

  const handlePageChange = (value) => {
    setPage(value)
  }

  const handleChangeRowsPerPage = (value) => {
    setPage(1)
    setRowsPerPage(value)
  }

  // useEffect(() => {
  //   getAllAccountsDetails()
  // }, [page, rowsPerPage])

  return (
    <>
      <Box p={2}>
        <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
        <Box className={classes.headerWrapper} display="flex" mb={2}>
          <Box flexGrow={1}>Programs</Box>
          {/* <Box ><RefreshIcon className={classes.refreshIcon} onClick={getAllAccountsDetails} /></Box> */}
        </Box>
        {loading ? <ComponentLoader loading={loading} style={{ height: '200px' }} /> :
          <>
            <TableOutline
              tableHeadings={tableHeadings}
              tableData={tableData}
              totalElement={totalCount}
              loading={loading}
              pagination={tableData.length > 0}
              page={page}
              rowsPerPage={rowsPerPage}
              handleChangePage={handlePageChange}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              rowsPerPageOptions={rowsPerPageOptions}
            />
          </>
        }
      </Box>
    </>
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser, isSuperAdmin } = auth
  return { currentUser, isSuperAdmin }
}

export default connect(mapStateToProps, {})(Accounts)